import Swiper from "swiper";
import { Navigation } from "swiper/modules";

(function () {
    const swiperSliders = document.querySelectorAll(".job-slider");

    let newsSwiper = [];

    for (let i = 0; i < swiperSliders.length; i++) {
        // const navigationWrapper = swiperSliders[i]
        //   .closest(".com-image-slider")
        //   .querySelector(".swiper-navigation");
        // const nextEl = navigationWrapper.querySelector(".swiper-button-next");
        // const prevEl = navigationWrapper.querySelector(".swiper-button-prev");

        newsSwiper[i] = new Swiper(swiperSliders[i], {
            modules: [Navigation],
            touchReleaseOnEdges: true,
            loop: false,
            direction: "vertical",
            autoHeight: true,
            slidesPerView: swiperSliders[i].dataset.slides,
            spaceBetween: 15,
            navigation: {
                nextEl: ".job-swiper-button-next",
                prevEl: ".job-swiper-button-prev",
            },
            on: {
                init: function () {
                  this.update(); // Aktualisiert die Swiper-Instanz nach der Initialisierung
                },
                resize: function () {
                  this.update(); // Aktualisiert bei Größenänderungen
                }
            }
        });
    }
})();
